module.exports = __webpack_public_path__ + "static/media/section-skill.cc2ad32b.png";